<template>
  <header>
    <img src="../assets/img/logosp.png" class="img-fluid w-50 my-3" />
  </header>
</template>

<script>
export default {};
</script>

<style scoped>
.img-fluid {
  width: 100%;
}
</style>